import styled from '@emotion/styled';
import { Flex } from '@lightspeed/flame/Core';
import { Spinner } from '@lightspeed/flame/Spinner';

export const InvoiceReferenceContainer = styled(Flex)`
  background-color: #d6e9ce;
  padding: 17px 36px 17px 54px;
  border-bottom: 1px solid #ccc;
`;

export const InvoiceReferenceLoading = styled(Flex)`
  gap: 14px;
  background-color: #d6e9ce;
  padding: 13px 36px 14px 14px;
  border-bottom: 1px solid #ccc;
`;
export const InvoiceReferenceSpinner = styled(Spinner)`
  margin: 0;
`;
